var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.6 0 30 13.4 30 30S48.6 62 32 62 2 48.6 2 32 15.4 2 32 2z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M39.8 28v.5c0 5.4-4.1 11.6-11.6 11.6-2.3 0-4.4-.7-6.2-1.8.3 0 .6.1 1 .1 1.9 0 3.7-.6 5.1-1.7-1.8 0-3.3-1.2-3.8-2.8.2 0 .5.1.8.1.4 0 .7 0 1.1-.1-1.9-.4-3.3-2-3.3-4v-.1c.5.3 1.2.5 1.8.5-1.1-.7-1.8-2-1.8-3.4 0-.7.2-1.4.5-2 2 2.5 5 4.1 8.4 4.2-.1-.3-.1-.6-.1-.9 0-2.2 1.8-4.1 4.1-4.1 1.2 0 2.2.5 3 1.3.9-.2 1.8-.5 2.6-1-.3 1-.9 1.7-1.8 2.3.8-.1 1.6-.3 2.3-.6-.6.6-1.3 1.3-2.1 1.9z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 32,
    cy: 32,
    r: 17,
    fill: "none",
    strokeWidth: 1.5
  })));
};
export default SvgTwitter;